export const swiperDefaultStyles = () => ({
  '.dn-swiper-wrapper': {
    borderRadius: '10px',
    overflow: 'hidden',
    border: '1px solid rgba(75, 75, 75, 0.1)',
    boxShadow: '0px 4px 10px rgba(75, 75, 75, 0.1)',
    '&.dn-swiper-footer-pagination .swiper': {
      paddingBottom: '40px',
      '&:after': {
        content: '""',
        position: 'absolute',
        background: 'white',
        left: '0',
        right: '0',
        height: '40px',
        bottom: '0',
        zIndex: '1',
      },
      img: {
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
      },
    },
  },
  '.swiper': {
    width: '100%',
    height: 'auto',
    '.swiper-button-next, .swiper-button-prev': {
      top: 'auto',
      bottom: '5px',
      width: '30px',
      height: '30px',
      color: '#2845D2',
      '&:after': {
        fontSize: '20px',
      },
    },
    '.swiper-pagination-bullet-active': {
      background: '#2845D2',
    },
    '.swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction': {
      bottom: '15px',
    },
    img: {
      borderRadius: '0px',
      overflow: 'hidden',
      maxWidth: '100%',
    },
  },
  '.dn-swiper-slide-width-auto': {
    width: 'auto',
  },
});

export const swiperStyles = () => ({
  '.dn-swiper-wrapper': {
    overflow: 'hidden',
  },
  '.swiper': {
    width: '100%',
    height: 'auto',
    '.swiper-button-next, .swiper-button-prev': {
      width: '35px',
      height: '35px',
      color: '#1C1B1F',
      background: 'rgba(0, 0, 0, 0.02);',
      borderRadius: '500px',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.1);',
      },
      '&:after': {
        fontSize: '16px',
        fontWeight: '900',
      },
    },
    img: {
      borderRadius: '0px',
      overflow: 'hidden',
      maxWidth: '100%',
    },
  },
  '.dn-swiper-media': {
    background: '#FFFFFF',
    border: '1px solid #F5F5F5',
    boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.05)',
    borderRadius: '10px',
    overflow: 'hidden',
    margin: '15px auto',
    maxWidth: '400px',
  },
  '.swiper-pagination': {
    display: 'none',
  },
  '.dn-swiper-slide-width-auto': {
    width: 'auto',
  },
  '.dn-navigation-outside': {
    '&.dn-swiper-lock': {
      '.swiper': {
        width: '100% !important',
      },
    },
    '.swiper': {
      width: 'calc(100% - 90px)',
      position: 'static !important',
      display: 'grid !important',
      '& [class^="swiper-button-"]': {
        inset: 'initial',
        margin: 0,
        alignSelf: 'center',
      },
      '& .swiper-button-prev': {
        justifySelf: 'start',
        marginLeft: '-45px',
      },
      '& .swiper-button-next': {
        justifySelf: 'end',
        marginRight: '-45px',
      },
      '& .swiper-pagination': {
        inset: 'initial !important',
        alignSelf: 'end',
        justifySelf: 'center',
        marginBottom: '-45px',
      },
    },
  },
});
